export const OLUP = 'olup'
export const UTZ = 'utz'

export const ALL_APPS = [
  OLUP,
  UTZ,
] as const

export type App = typeof ALL_APPS[number]
